/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/forbid-dom-props */
/* eslint-disable max-len */
//
// NB: This Subscribe feature and it's associated Components are for a high
//     volume signup test conducted in a joint partnership with Agent
//     Advice.
//     More details at https://catalyzeai.atlassian.net/wiki/spaces/CC/pages/47513601/Agent+Advice+High+Volume+Signup+Test
//
//
import { yupResolver } from '@hookform/resolvers/yup';
// import { isEmpty, clone, values, sumBy, cloneDeep } from 'lodash';
import { isEmpty } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { toast } from 'react-hot-toast';
// import { useQueryClient } from 'react-query';
import CreatableSelect from 'react-select/creatable';

import {
    // Button,
    // ButtonVariant,
    getBorderShadow,
    HttpStatus,
    PublicLayout,
    StyledLabel,
    theme,
    Toast,
} from '@catalyze/ui';
// import type { IProductsInfo, IPropertyCount } from 'api/products/getProducts';
// import { fetchProducts } from 'api/products/getProducts';
import { useGetSubscribeOptions } from 'api/subscriptions/getSubscriptions';
// import { useSelectSubscriptionMultipleMutation } from 'api/subscriptions/selectMultpleSubscriptions';
import { useSubscribeOptionMutation } from 'api/subscriptions/selectSubscribeOption';
// import type { IUserProfile } from 'api/types/user';
// import { fetchUser } from 'api/users/getUser';
import { useGetZipcodesMutation } from 'api/zipcodes/getZipcode';
import { LoadingOverlay } from 'components/LoadingOverlay';
import { FormLine } from 'features/Profile/components/FormLine';
import { CardContainer } from 'features/SignUp/components/CardContainer';
import { StyledForm } from 'features/SignUp/components/Form';
import { InputContainer } from 'features/SignUp/components/forms/AccountDetailsForm/styled';
import { Spacer } from 'features/SignUp/components/forms/DocusSignForm/styled';
import { FormTitle } from 'features/SignUp/components/FormTitle';
import { useOptionsWithSearch } from 'features/SignUp/hooks/useOptionsWithSearch';
import { locationSchema } from 'schemas/signUpForm';
// import { stateNameToAbbreviation } from 'utils/states';

import {
    // StyledButtonContainer,
    // StyledFooter,
    // StyledFooterTextContainer,
    StyledPlanAGAD,
} from './styled';

// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { SelectContainer } from '../../../../../../../libs/ui/src/components/FormSelect/styled';

export const Subscribe = () => {
    // const queryClient = useQueryClient();
    // const [productState, setProductState] = useState({});
    const formMethods = useForm({
        resolver: yupResolver(locationSchema),
    });
    const { getValues, setError, clearErrors, setValue } = formMethods;
    const value = getValues().zip;
    const [searchValue, setSearchValue] = useState('');
    const [placeHolderValue, setPlaceHolderValue] = useState('');
    const {
        data: zipCodeData,
        mutate: searchApi,
        isLoading: isZipCodeLoading,
    } = useGetZipcodesMutation({});

    const { error, isLoading: isZipLoading } = useOptionsWithSearch({
        search: searchValue,
        prefetchValue: value || '',
    });
    const [zipOptions, setZipOptions] = useState([]);
    const [isPageLoading, setIsLoading] = useState(true);
    // const [count, setCount] = useState<IProductsInfo>({
    //     count: -1,
    //     re_low: -1,
    //     re_high: -1,
    //     dist_hi: [],
    //     dist_lo: [],
    // });
    const { data: subscriptions, isLoading: isSubcriptionsLoading } =
        useGetSubscribeOptions({});

    // eslint-disable-next-line max-len
    // const fetchProductsByZip = async (zip: string) => {
    //     await queryClient.invalidateQueries('products');

    //     return await queryClient.fetchQuery(['products', { zip }], () =>
    //         fetchProducts(zip)
    //     );
    // };

    const { mutate } = useSubscribeOptionMutation({
        onSuccess: (data) => {
            window.location.href = data.redirectUrl;
        },
        onError: async () => {
            toast(
                () => (
                    <Toast title="An error occurred please try again momentarily." />
                ),
                {
                    style: { backgroundColor: 'red' },
                }
            );
        },
    });

    useEffect(() => {
        if (!zipCodeData) return;
        const usedZipCodes = new Set();
        const updatedOptions = [
            ...zipOptions,
            {
                value: getValues().zip,
                label: `${zipCodeData?.city}, ${zipCodeData?.state} ${
                    getValues().zip
                }`,
                state: zipCodeData?.state || '',
            },
        ];
        setZipOptions(
            // @ts-expect-error error
            updatedOptions
                .filter((option: any) => {
                    if (!usedZipCodes.has(option.value)) {
                        usedZipCodes.add(option.value);
                        return true;
                    }

                    return false;
                })
                .filter((value) => !isEmpty(value))
        );
        setPlaceHolderValue(
            `${zipCodeData?.city}, ${zipCodeData?.state} ${getValues().zip}`
        );

        setValue('state', zipCodeData?.state);
        setValue('zip', getValues().zip);
    }, [zipCodeData, setValue]);

    // useEffect(() => {
    //     const formattedData: any = {};
    //     if (isEmpty(productState)) {
    //         subscriptions?.forEach((item: any) => {
    //             formattedData[item.id] = {
    //                 ...item,
    //                 count: 0,
    //                 isAdded: false,
    //             };
    //         });

    //         setProductState(formattedData);
    //     }
    // }, [subscriptions, productState]);

    const formatAndCallStripe = (count: number, priceId: string) => {
        const payload: any = {
            zip: getValues().zip,
            platform: 'realEstate_AGAD',
            priceId,
            count,
        };

        // values(productState).forEach((item: any) => {
        //     if (item.isAdded) {
        //         payload.data.push({
        //             priceId: item.id,
        //             count: item.count,
        //             // @ts-ignore initial work
        //             productEnum: item.product.toLowerCase().includes('over')
        //                 ? 're_high'
        //                 : 're_low',
        //         });
        //     }
        // });

        mutate({ ...payload });
    };

    const fetchInitialData = async () => {
        // const userData: IUserProfile = await queryClient.fetchQuery(
        //     'users/me',
        //     () => fetchUser()
        // );

        const zip = localStorage.getItem('target_zip') ?? '10001';

        setIsLoading(false);
        setValue('zip', zip);
        // setValue('state', userData.state);
        searchApi({ code: zip });
        // const productData = await fetchProductsByZip(userData.zip);
        // setCount(productData);
    };

    const onZipCodeUpdate = async (zip: string) => {
        setIsLoading(true);
        // const productData = await fetchProductsByZip(zip);
        // setCount(productData);

        localStorage.setItem('target_zip', zip);

        setIsLoading(false);
    };

    useEffect(() => {
        void fetchInitialData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Limits characters to numbers of max length
    const setValidSearchValue = useCallback(
        (test: string) => {
            const val = test.replace(/[^0-9]/u, '').slice(0, 5);
            setSearchValue(val);
        },
        [setSearchValue]
    );

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    // const onReadyForCheckout = (count: number, sub: any) => {
    //     mutate({
    //         // @ts-ignore initial work
    //         priceId: sub.id,
    //         count,
    //         zip: getValues('zip'),
    //         state: getValues('state'),
    //     });
    // };

    // const total = useMemo(() => {
    //     return sumBy(
    //         values(productState).filter((item: any) => item.isAdded),
    //         (item: any) => item.count * (Number(item.price.amount) / 100)
    //     );
    // }, [productState]);

    // Sets error if zip is not found
    useEffect(() => {
        if (error?.response) {
            setError('zip', {
                message:
                    Number(error?.response.status || 0) === HttpStatus.NOT_FOUND
                        ? 'Zip code not found'
                        : 'Error occured, please try again',
            });
        } else {
            clearErrors('zip');
        }
    }, [error, setError, clearErrors]);

    return (
        <PublicLayout>
            <CardContainer style={{ marginBottom: 100 }}>
                <LoadingOverlay
                    shown={
                        isSubcriptionsLoading ||
                        isPageLoading ||
                        isZipCodeLoading
                    }
                />
                <FormTitle
                    title="Catalyze AI Subscription"
                    subtitle={
                        <>
                            <b>
                                <span style={{ color: 'black' }}>
                                    Follow the below steps to sign up:
                                </span>
                            </b>
                            <br />
                            <span style={{ color: 'black' }}>
                                <ol style={{ paddingLeft: '25px' }}>
                                    <li style={{ paddingBottom: '5px' }}>
                                        Type in and select your desired zip code
                                    </li>
                                    <li style={{ paddingBottom: '5px' }}>
                                        Select the number and type of leads you
                                        want by clicking the desired option
                                    </li>
                                </ol>
                            </span>
                            <br />
                            <b>
                                <span style={{ color: 'black' }}>
                                    Other Notes:
                                </span>
                            </b>
                            <span style={{ color: 'black' }}>
                                <ul style={{ paddingLeft: '25px' }}>
                                    <li>
                                        Leads will populate onto the platform
                                        when you finish signing up as well as
                                        the first of every month.
                                    </li>
                                    <li>
                                        Once you have successfully signed up,
                                        you will be charged every month on the
                                        day that you signed up unless you cancel
                                        before.
                                    </li>
                                </ul>
                            </span>
                        </>
                    }
                />
                <FormProvider {...formMethods}>
                    <StyledForm>
                        <FormLine>
                            <InputContainer>
                                <SelectContainer hasError={false}>
                                    <StyledLabel htmlFor="zipcode-select">
                                        Zip Code For Products
                                    </StyledLabel>
                                    <CreatableSelect
                                        id="zipcode-select"
                                        value={() =>
                                            zipOptions.find(
                                                (option: any) =>
                                                    option.value === value
                                            )
                                        }
                                        formatCreateLabel={(value) =>
                                            `Search for ${value}`
                                        }
                                        // eslint-disable-next-line @typescript-eslint/require-await
                                        onCreateOption={async (value) => {
                                            setValue('zip', value);
                                            searchApi({ code: value });
                                            void onZipCodeUpdate(value);
                                        }}
                                        options={zipOptions}
                                        onChange={(val: any) => {
                                            setValue('state', val.state);
                                            setValue('zip', val.value);
                                            setPlaceHolderValue(val.label);
                                            void onZipCodeUpdate(val.value);
                                        }}
                                        onInputChange={setValidSearchValue}
                                        inputValue={searchValue}
                                        isLoading={
                                            isZipLoading || isZipCodeLoading
                                        }
                                        placeholder={placeHolderValue}
                                        isDisabled={isZipLoading}
                                        styles={{
                                            indicatorSeparator: (provided) => ({
                                                ...provided,
                                                display: 'none',
                                            }),
                                            container: (provided) => ({
                                                ...provided,
                                                color: theme.colors.formLabel,
                                                fontSize: theme.fontSizes[3],
                                            }),
                                            dropdownIndicator: (provided) => ({
                                                ...provided,
                                                color: 'white',
                                            }),
                                            indicatorsContainer: (
                                                provided
                                            ) => ({
                                                ...provided,
                                                backgroundColor: 'lightgreen',
                                            }),
                                            control: (provided, state) => ({
                                                ...provided,
                                                height: '2.25rem',
                                                minHeight: '2.25rem',
                                                borderRadius: '0.375rem',
                                                border: 'none',
                                                boxShadow: getBorderShadow(
                                                    Boolean(error),
                                                    state.isFocused
                                                ),
                                                '&:hover, &:focus': {
                                                    outline: 'none',
                                                    boxShadow: getBorderShadow(
                                                        Boolean(error),
                                                        state.isFocused
                                                    ),
                                                },
                                            }),
                                            input: (provided, state) => ({
                                                ...provided,
                                                height: 'auto',
                                            }),
                                        }}
                                    />
                                </SelectContainer>
                            </InputContainer>
                        </FormLine>
                    </StyledForm>
                </FormProvider>
                <br />

                {subscriptions?.map((sub) => (
                    <StyledPlanAGAD
                        key={sub.id}
                        loading={isPageLoading}
                        // this is actually a priceId
                        subscriptionId={sub.id}
                        // propertyDistribution={propertyDistribution}
                        // count={propertyCount}
                        name={sub.product}
                        zip={getValues().zip}
                        // @ts-expect-error error
                        description={sub.description}
                        // useCount
                        // onProductSelectionUpdate={(
                        //     count: number,
                        //     isAddedToCart: boolean
                        // ) => {
                        //     if (!isEmpty(productState)) {
                        //         const cloned: any = clone(productState);
                        //         cloned[sub.id].isAdded = isAddedToCart;
                        //         cloned[sub.id].count = count;

                        //         setProductState(cloned);
                        //     }
                        // }}
                        billingPeriod={sub.interval.unit}
                        price={sub.price.amount}
                        onSubscribe={formatAndCallStripe}
                    />
                ))}
                <Spacer />
            </CardContainer>
        </PublicLayout>
    );
};
